<div class="wrapper border rounded-[5px] p-[15px]">
  <div class="row flex flex-col mb-[20px]">
    <div class="label">
      Lab Contacts:
    </div>
    <div class="value">
      {{ data?.lab?.email }} | {{ data?.lab?.phone }}
    </div>
  </div>
  <div
    [ngClass]="{
    'mb-[40px]': data?.status === 'sent_to_lab',
    'mb-[20px]': data?.status !== 'sent_to_lab'
  }"
    class="row flex flex-col">
    <div class="label">
      Received on:
    </div>
    <div class="value">
      {{ data?.lab?.email }}
    </div>
  </div>
  @if (data?.status === 'sent_to_lab') {
    <div class="action-section mb-[20px]">
      <app-primary-button (handleClick)="accept()">
        Accept Schedule
      </app-primary-button>
    </div>
  }
</div>
